import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../../icon/icon.component';
import { ARROW_SIZE, defaultContext, getInitialStyle } from './scroll.style';
import ScrollShader from './scroll.shader';

export class Scroll extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Up: {
          type: Icon,
        },
        Pane: {
          rtt: true,
          shader: {
            type: ScrollShader,
          },
        },
        Down: {
          type: Icon,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._offset = 0;
    this._contentHeight = 0;
    this._minOffset = 0;
    this._shouldScroll = false;
  }

  _detach() {
    this._style = undefined;
    this._offset = 0;
    this._contentHeight = 0;
    this._minOffset = 0;
    this._shouldScroll = false;
  }

  set content(value) {
    const pane = this.tag('Pane');

    const current = pane.childList.getByRef('Wrapper');
    if (current) {
      current.removeAllListeners('txLoaded');
      pane.childList.remove(current);
    }

    const child = this.stage.c(value);
    child.on('txLoaded', () => {
      this._shouldScroll = child.finalH > this.h;
      const offset = this._shouldScroll ? ARROW_SIZE[this._style.screenSize] : 0;
      this._minOffset = this.h - child.finalH - ARROW_SIZE[this._style.screenSize] * 2;

      pane.patch({
        w: this.w,
        h: this.h - offset * 2,
        y: offset,
      });

      this.tag('Up').visible = this._shouldScroll;

      this.tag('Down').patch({
        visible: this._shouldScroll,
        y: this.h,
      });

      this._updateOffset(0);
    });
    child.ref = 'Wrapper';
    pane.childList.add(child);
  }

  get content() {
    return this.tag('Pane').childList.getByRef('Wrapper');
  }

  _updateOffset(direction) {
    const { content } = this;

    if (!content) {
      return;
    }

    const pane = this.tag('Pane');

    content.setSmooth('y', this._offset);
    this.tag('Up').setSmooth('alpha', this._offset >= 0 ? 0 : 1);
    this.tag('Down').setSmooth('alpha', this._offset <= this._minOffset ? 0 : 1);
    pane.setSmooth('shader.top', this._offset >= 0 ? 0 : 1, { delay: direction > 0 ? 0.11 : 0 });
    pane.setSmooth('shader.bottom', this._offset <= this._minOffset ? 0 : 1, { delay: direction < 0 ? 0.11 : 0 });
  }

  _handleUp() {
    if (!this._shouldScroll) {
      return true;
    }

    this._offset = Math.min(this._offset + 100, 0);
    this._updateOffset(1);

    return true;
  }

  _handleDown() {
    if (!this._shouldScroll) {
      return true;
    }

    this._offset = Math.max(this._offset - 100, this._minOffset);
    this._updateOffset(-1);

    return true;
  }
}
